import { checkIsAutomatedBrowser } from '@/bot-detection/checkIsAutomatedBrowser.ts';
import { getHydraConfig } from '@/config/hydra';
import { getNinjaConfig } from '@/config/ninja';
import { getRegionConfig } from '@/config/region';
import { GIT_HASH, STAGE } from '@/const/env.ts';
import { state } from '@/ninja/state';
import { Event } from '@/types/events';
import { DefaultParams } from '@/types/params';

/**
 * Get list of default properties shared between trackers
 */
export function getNinjaDefaultParams(event: Event) {
  const hydraConfig = getHydraConfig();
  const regionConfig = getRegionConfig();
  const defaultParams: Partial<DefaultParams> = {
    stage: STAGE,
  };

  if (hydraConfig?.params?.cC) {
    defaultParams.cC = hydraConfig.params.cC;
  }
  if (hydraConfig?.params?.bR) {
    defaultParams.bR = hydraConfig.params.bR;
  }

  // Matrix Version
  if (regionConfig?.version) {
    defaultParams.mv = regionConfig.version;
  }

  // ninja version - we don't increase the semver of the packege. Use the commit hash
  if (GIT_HASH) {
    defaultParams.ninjaVer = GIT_HASH;
  }

  // Environment - mark all events generated during a Playground session
  if (state.playgroundMode) {
    defaultParams.env = 'playground';
  } else if (getNinjaConfig().environment !== 'production') {
    defaultParams.env = 'dev';
  }

  // Sheep bot detection
  defaultParams.sh = checkIsAutomatedBrowser();

  // eventType
  if (event.actionType == 'trackEvent') {
    defaultParams.tN = 'e';
  } else if (event.actionType == 'trackPage') {
    defaultParams.tN = 'p';
  }

  return defaultParams;
}
